//* Libraries imports
import { Logo } from "@/assets";

export function PaymentHeader() {
  return (
    <header className="w-full max-w-3xl flex flex-col items-center gap-4">
      <div className="w-40 h-12 flex items-center justify-center bg-white rounded-lg shadow-sm border border-clarobordas-01 overflow-hidden">
        <Logo />
      </div>
      <h1 className="text-clarotexto-201 text-xl md:text-2xl font-semibold text-center whitespace-pre-line">
        Bem-vindo ao Fluxo de{"\n"}Pagamento
      </h1>
    </header>
  );
}
